import React, { useState } from "react";
import { useParams } from "react-router-dom";
import HubLayout from "../Layout";
import HubHeader from "../Layout/topHeader";

import { ZoomInOutlined, ZoomOutOutlined } from "@ant-design/icons";
import { Button, Drawer, Form } from "antd";
import AreaList from "../../Area";
import AddArea from "../../Area/AddArea";

const HubAreaList = ({ params }: any) => {
  const route = useParams();
  const [form] = Form.useForm();
  const [activeSearch, setActiveSearch] = useState(false);
  const [visible, setVisible] = useState(undefined);
  const [refetchState, setRefetchState] = useState(false)

  const showDrawer = () => {
    setVisible(true);
  };

  const onDrawerClose = () => {
    setVisible(false);
    // refetch();
    form.resetFields();
    setRefetchState(true)
  };

  return (
    <React.Fragment>
      <HubLayout hubId={(route as any)?.hubId as string}>
        <div className="product-list-item-area white-bg">
          <HubHeader
            leftarea={"Area List"}
            rightarea={
              <div className="d-flex">
                {activeSearch ? (
                  <Button
                    type="text"
                    danger
                    onClick={() => {
                      setActiveSearch(false);
                    }}
                    className="mr-2"
                  >
                    <ZoomOutOutlined />
                  </Button>
                ) : (
                  <Button
                    type="text"
                    onClick={() => {
                      setActiveSearch(true);
                    }}
                    className="mr-2"
                  >
                    <ZoomInOutlined />
                  </Button>
                )}
                <Button type="primary" danger onClick={showDrawer}>
                  Add New
                </Button>
              </div>
            }
          />
          <AreaList inHub={true} activeSearch={activeSearch} refetch={refetchState} />

          <Drawer
            destroyOnClose={true}
            title="Add Area"
            width={500}
            onClose={onDrawerClose}
            visible={!!visible}
            bodyStyle={{ paddingBottom: 0 }}
            footer={
              <div
                style={{
                  textAlign: "left",
                }}
              ></div>
            }
          >
            <AddArea inHub={true} onCloseMethod={onDrawerClose} />
          </Drawer>
        </div>
      </HubLayout>
    </React.Fragment>
  );
};

export default HubAreaList;
